module.exports = __webpack_public_path__ + "img/less_equal.b8493f4f.svg";